import React from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useTheme } from '../Context/ThemeContext';
import { useLanguage } from '../Context/LanguageContext';
import './ThemeToggle.css';

export default function ThemeToggle({ className = '' }) {
    const { theme, toggleTheme } = useTheme();
    const { language } = useLanguage();
    const light = theme === 'light';
    const label = language === 'sv'
        ? (light ? 'Byt till mörkt tema' : 'Byt till ljust tema')
        : (light ? 'Switch to dark theme' : 'Switch to light theme');

    return (
        <button type="button" className={`theme-toggle ${className}`} onClick={toggleTheme} aria-label={label} title={label}>
            {light ? <FaMoon aria-hidden="true" /> : <FaSun aria-hidden="true" />}
        </button>
    );
}
